module.exports = __webpack_public_path__ + "img/brandLogo.f27de62d.png";